module.exports = __webpack_public_path__ + "static/media/logo.c3239ea7.png";